var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBagFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.366 3.4375L18.577 8.9995H22V10.9995H20.833L20.076 20.0825C20.0552 20.3324 19.9413 20.5653 19.7568 20.7352C19.5723 20.905 19.3308 20.9994 19.08 20.9995H4.92C4.66925 20.9994 4.4277 20.905 4.24322 20.7352C4.05875 20.5653 3.94481 20.3324 3.924 20.0825L3.166 10.9995H2V8.9995H5.422L8.634 3.4375L10.366 4.4375L7.732 8.9995H16.267L13.634 4.4375L15.366 3.4375ZM13 12.9995H11V16.9995H13V12.9995ZM9 12.9995H7V16.9995H9V12.9995ZM17 12.9995H15V16.9995H17V12.9995Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBagFill);
export default __webpack_public_path__ + "static/media/icon-bag-fill.432b64b7bd6ee19f58eb30cca8643b5d.svg";
export { ForwardRef as ReactComponent };